export default __webpack_public_path__ + "Assets/PREMIUM/baden_wuerttemberg/Ablauf_Beantragung_Online-Zugang.pdf";